import axios from "axios";

export default {
    namespaced: true,
    state: {
        e_invoice: {},
    },
    mutations: {
        updateService(state, {service, data}) {
            state[service] = data;
        }
    },
    getters: {
        e_invoice: state => state.e_invoice
    },
    actions: {
        getEInvoiceServiceData({commit, rootState}){
            return new Promise((resolve, reject) => {
                let url = rootState.appUrl + '/customer/api/e-invoice'
                return axios.get(url, { errorHandle: false }).then(function (response) {
                    commit('updateService', { service: 'e_invoice', data: response.data.data.attributes});
                    resolve(response.data.data.attributes)
                }).catch(() => {});
            })
        },
    },

};
